import type { AxiosResponse } from 'axios';
import HttpClientService from '../../config/HttpClient';
import { trackException } from '../appInsights';

export default class HttpClientsService {
  api: HttpClientService;

  constructor() {
    this.api = new HttpClientService();
  }

  getMarketplaceAcceptOrderReturn = (id: string) => {
    return this.api.get(`v1/marketplaces/${id}/accept_order_return`);
  };

  getClientAcceptOrderReturn = (id: string) => {
    return this.api.get(`v1/clients/${id}/accept_order_return`);
  };

  getVerifyDropLotNumber = (
    marketplaceId: string
  ): Promise<AxiosResponse<boolean>> => {
    return this.api.get(`v1/marketplaces/${marketplaceId}/drop_bag`);
  };

  postRequireCollectionDrop = (payload: any) => {
    return this.api.post(
      `v1/marketplaces/require_data_collection_on_drop`,
      payload
    );
  };

  getMarketplacesRequiredSeal = (id: string) => {
    const response = this.api
      .get(`v1/marketplaces/${id}/drop_bag`)
      .catch((error: any) => {
        trackException(
          { exception: error },
          { error_response: error?.response || 'Erro não identificado' }
        );
        throw error;
      });

    return response;
  };
}
